module.exports = __webpack_public_path__ + "img/righttext.bfdd87d5.svg";